import { PROMO_BANNER_MAX_HEIGHT, PROMO_BANNER_MAX_WIDTH } from '../consts';

type FitPromoBannerSizeParams = {
  mediaWidth?: number | null;
  mediaHeight?: number | null;
  maxWidth?: number;
  maxHeight?: number;
};

type FittedPromoBannerSize = {
  width: number;
  height: number;
};

export const fitPromoBannerSize = ({
  mediaWidth,
  mediaHeight,
  maxWidth = PROMO_BANNER_MAX_WIDTH,
  maxHeight = PROMO_BANNER_MAX_HEIGHT,
}: FitPromoBannerSizeParams): FittedPromoBannerSize => {
  const sourceWidth = mediaWidth && mediaWidth > 0 ? mediaWidth : maxWidth;
  const sourceHeight = mediaHeight && mediaHeight > 0 ? mediaHeight : maxHeight;
  const scale = Math.min(maxWidth / sourceWidth, maxHeight / sourceHeight);

  return {
    width: Math.round(sourceWidth * scale),
    height: Math.round(sourceHeight * scale),
  };
};
